





















import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { AA } from "@/lib/mixin";
import {aplusButtonClick, aplusSendPV, aplusVideoClick} from "@/lib/qtLIb";
import WeixinMixin from '../shared/weixin-mixin';
import { AbsCatalog } from '@/shared/catalog.model';
import { getArticle } from '@/shared/api';
import { isIOS } from '@/shared/utils';

// https://github.com/tclyjy/wechat-h5-video
// https://juejin.im/post/6844903558345654285

@Component
export default class VideoPlayer extends Mixins(Vue, AA, WeixinMixin) {
  @Prop(String) readonly articleId!: string;

  article: Article = {
    id: 0,
    thumbnail: '',
    url: '',
    title: '',
    type: ''
  };

  isLoading = true;
  isFirstPlay = true;

  get video(): HTMLVideoElement {
    return this.$refs["videoScreen"] as HTMLVideoElement;
  }

  get categories(): Array<AbsCatalog> {
    return this.$store.getters.catalogs;
  }

  get videoTitle(): string {
    return this.article?.title ?? ''
  }

  created() {
    const articleId = parseInt(this.articleId);
    const article = this.findArticle(articleId);
    if (article) {
      this.article = article;
    } else {
      getArticle(articleId).then(res => {
        this.article = res;
        console.log('%c [ res ]-70-「views/VideoPlayer.vue」', 'font-size:13px; background:pink; color:#bf2c9f;', res)
        window.wx.ready(() => {
          this.setupShare();
          this.setupTimelineShare();
        });
        setTimeout(() => {
          this.video.load();
        }, 100);
      }).catch(err => {
        console.error('load article error', err);
        this.$router.replace('/404')
      });
    }
    this.tracking({ isAction: false, pageName : `video-player_${articleId}` })
  }

  mounted() {
    console.log('article.url: ', this.article?.url);
    this.video.addEventListener("playing", this.onPlaying);
    this.video.addEventListener("progress", this.onProgress);
    this.video.addEventListener("ended", this.onEnd);
    if (isIOS) {
      window.document.addEventListener("WeixinJSBridgeReady", this.touchPlay, false);
    } else {
      this.video.play();
    }
    window.addEventListener("resize", this.renderResize, false);
    this.renderResize();

    if (this.article && this.article?.title.length > 20) {
      const title: Element = this.$refs["video-title"] as Element;
      title.className = title.className + ' small';
    }
  }

  beforeDestroy() {
    this.video.removeEventListener("ended", this.onEnd);
    this.video.removeEventListener("progress", this.onProgress);
    this.video.removeEventListener("playing", this.onPlaying);
    if (isIOS) {
      window.document.removeEventListener("WeixinJSBridgeReady", this.touchPlay, false);
    }
    window.removeEventListener("resize", this.renderResize, false);

    let rate = Math.round(this.video.currentTime * 10 / this.video.duration) * 10;
    if (isNaN(rate) || rate < 0) {
      rate = 0;
    } else if (rate > 100) {
      rate = 100;
    }
    const pvTrackData = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      page_name: 'play_video_page'
    };
    aplusSendPV(pvTrackData);

    aplusVideoClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: 'play_video_clk',
      // eslint-disable-next-line @typescript-eslint/camelcase
      video_name:  `${this.videoTitle}`,
      // eslint-disable-next-line @typescript-eslint/camelcase
      is_watch_end: rate === 100,
      // eslint-disable-next-line @typescript-eslint/camelcase
      video_rate: rate,
      'video_id': `${this.article.id}`,
      'title_type': window.sessionStorage.getItem('currentCatalog'),
    })
    // this.pageTracking(`played_${this.videoTitle}_${rate}`);
  }

  renderResize() {
    const title: Element = this.$refs["video-title"] as Element;

    const width = document.documentElement.clientWidth;
    const height = document.documentElement.clientHeight;
    console.log(`viewport: ${width} X ${height}`);

    const isPortrait = height >= width;
    const leftStyle = isIOS ? 'left: 7rem' : '';
    if (isPortrait) {
      this.video.style.width = `${width}px`;
      this.video.style.height = `auto`;
      const videoWidth = this.video.getBoundingClientRect().width;
      const videoHeight = this.video.getBoundingClientRect().height;
      console.log(`video: ${videoWidth} X ${videoHeight}`);
      let playerTop = this.video.getBoundingClientRect().top;
      if (videoWidth > videoHeight) {
        playerTop = (height - videoWidth * 10 / 16) / 2;
      }

      const titleHeight = title.getBoundingClientRect().height;
      let titleTop = playerTop - titleHeight;
      const minTop = 10;

      console.log(`playerTop: ${playerTop}; titleTop: ${titleTop}`);

      const titleLen = this.article?.title.length ?? 0;
      let needSmall = titleLen > 20;
      if (titleTop < minTop) {
        titleTop = minTop;
      }
      if (playerTop <= minTop + titleHeight * 0.3) {
        title.setAttribute('style', `top: ${Math.round(titleTop)}px; ${leftStyle};color: #000;`);
        needSmall = isIOS;
      } else {
        title.setAttribute( 'style', `top: ${Math.round(titleTop)}px;left: 0;`);
      }

      if (needSmall) {
        if (titleLen > 25) {
          title.className = title.className + ' xs';
        } else {
          title.className = title.className + ' small'
        }
      }
    } else {
      this.video.style.width = `${width}px`;
      this.video.style.height = `${height}px`;
      title.setAttribute('style', `top: 8px; ${leftStyle};color: #fff;`);
      title.className = title.className.replaceAll('small', '').replaceAll('xs', '');
    }
  }

  touchPlay() {
    this.video.play();
  }

  onPlaying() {
    this.pageTracking(`vpp_play_start`);
    if (this.isFirstPlay) {
      this.isFirstPlay = false;
      window.setTimeout(this.renderResize, 500);
    }
  }

  onProgress() {
    if (this.isFirstPlay) {
      this.isFirstPlay = false;
      window.setTimeout(this.renderResize, 500);
    }
  }

  onEnd() {
    this.pageTracking(`vpp_play_end`);
  }

  pageTracking(actionName: string): void {
    aplusSendPV(actionName);
    aplusButtonClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: actionName,
      // eslint-disable-next-line @typescript-eslint/camelcase
      button_name: 'video_player'
    })
  }

  findArticle(articleId: number): Article | undefined {
    for (const tab of this.categories) {
      for (const module of (tab as AbsCatalog)?.catalogs ?? []) {
        for (const catalog of (module as AbsCatalog)?.catalogs ?? []) {
          for (const article of (catalog as AbsCatalog)?.articles ?? []) {
            if (article && article.id === articleId) {
              return article;
            }
          }
        }
      }
    }
    return undefined;
  }

  public setupShare() {
    if (this.article.id === 0) {
      return;
    }

    window.wx.updateAppMessageShareData({
      title: this.article?.title,
      imgUrl: this.article?.thumbnail,
      link: this.shareUrl,
      success: () => {
        console.debug('updateAppMessageShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateAppMessageShareData failed: ', res);
      }
    });
  }

  public setupTimelineShare() {
    if (this.article.id === 0) {
      return;
    }

    window.wx.updateTimelineShareData({
      title: this.article?.title,
      imgUrl: this.article?.thumbnail,
      link: this.shareUrl,
      success: () => {
        console.debug('updateAppMessageShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateAppMessageShareData failed: ', res);
      }
    });
  }
}
